/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { Controller } from "stimulus";
import { calculateDifference } from "./difference.js";
import deklinacja from "deklinacja-od-ilosci";

export default class Countdown extends Controller {
	currentIndex = 0;
	interval_id!: number;

	declare dateValue: string;

	static values = {
		date: String,
	};

	static targets = [
		"day",
		"dayLabel",
		"hour",
		"hourLabel",
		"minute",
		"minuteLabel",
		"second",
		"secondLabel",
		"ticker",
	];
	declare readonly dayTarget: HTMLDivElement;
	declare readonly dayLabelTarget: HTMLDivElement;
	declare readonly hourTarget: HTMLDivElement;
	declare readonly hourLabelTarget: HTMLDivElement;
	declare readonly minuteTarget: HTMLDivElement;
	declare readonly minuteLabelTarget: HTMLDivElement;
	declare readonly secondTarget: HTMLDivElement;
	declare readonly secondLabelTarget: HTMLDivElement;
	declare readonly tickerTarget: HTMLDivElement;

	async connect() {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		this.interval_id = setInterval(() => this.tick(), 1000) as unknown as number;
		this.tickerTarget.style.setProperty("animation", "none"); // we're gonna animate it ourselves to keep it in sync with the js-changed seconds countdown
	}

	async disconnect() {
		clearInterval(this.interval_id);
	}

	tick() {
		const { days, hours, minutes, seconds } = calculateDifference(this.dateValue);
		const days_word = deklinacja(days, "dzień", "dni", "dni");
		const hours_word = deklinacja(hours, "godzina", "godziny", "godzin");
		const minutes_word = deklinacja(minutes, "minuta", "minuty", "minut");
		const seconds_word = deklinacja(seconds, "sekunda", "sekundy", "sekund");
		this.dayTarget.textContent = days.toString();
		this.dayLabelTarget.textContent = days_word.toString();
		this.hourTarget.textContent = hours.toString();
		this.hourLabelTarget.textContent = hours_word.toString();
		this.minuteTarget.textContent = minutes.toString().padStart(2, "0");
		this.minuteLabelTarget.textContent = minutes_word.toString().padStart(2, "0");
		this.secondTarget.textContent = seconds.toString().padStart(2, "0");
		this.secondLabelTarget.textContent = seconds_word.toString().padStart(2, "0");
		this.tickerTarget.style.setProperty("opacity", seconds % 2 ? "0" : "1");
	}
}
